import script from "./DashboardGraphic.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardGraphic.vue?vue&type=script&setup=true&lang=js"

import "./DashboardGraphic.vue?vue&type=style&index=0&id=78845494&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78845494"]])

export default __exports__